import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, TransitionGroup as _TransitionGroup, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "toast-container" }
const _hoisted_2 = { class: "toast-icon" }
const _hoisted_3 = { class: "toast-message" }
const _hoisted_4 = { class: "confirm-card" }
const _hoisted_5 = { class: "confirm-message" }
const _hoisted_6 = { class: "confirm-actions" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_TransitionGroup, { name: "toast" }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.toasts, (toast) => {
            return (_openBlock(), _createElementBlock("div", {
              key: toast.id,
              class: _normalizeClass(['toast', `toast--${toast.type}`])
            }, [
              _createElementVNode("span", _hoisted_2, _toDisplayString(toast.type === 'error' ? '✕' : toast.type === 'success' ? '✓' : 'ℹ'), 1),
              _createElementVNode("span", _hoisted_3, _toDisplayString(toast.message), 1)
            ], 2))
          }), 128))
        ]),
        _: 1
      })
    ]),
    (_ctx.state.confirms.length > 0)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "confirm-overlay",
          onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.resolve(false)), ["self"]))
        }, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.state.confirms[0].message), 1),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("button", {
                class: "btn btn-ghost",
                type: "button",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.resolve(false)))
              }, "Cancelar"),
              _createElementVNode("button", {
                class: "btn btn-danger",
                type: "button",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.resolve(true)))
              }, "Confirmar")
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}